import type { FilterField } from './advancedFilter.types';

interface DateLimits {
  minDate: string | undefined;
  maxDate: string | undefined;
}

function readLinkedDate(
  values: Record<string, string>,
  linkedKey: string | undefined,
): string | undefined {
  if (linkedKey === undefined) return undefined;
  return values[linkedKey] || undefined;
}

export function getDateLimits(field: FilterField, values: Record<string, string>): DateLimits {
  return {
    minDate: field.minDate ?? readLinkedDate(values, field.minDateKey),
    maxDate: field.maxDate ?? readLinkedDate(values, field.maxDateKey),
  };
}
